// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconCart: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="currentColor">
            <path
                fill="#999"
                d="M635.912891,1215.125 C635.188008,1215.125 634.625,1215.71262 634.625,1216.4375 C634.625,1217.16238 635.212617,1217.75 635.912891,1217.75 C636.613165,1217.75 637.200782,1217.16238 637.200782,1216.4375 C637.200782,1215.71262 636.662109,1215.125 635.912891,1215.125 Z M628.037891,1215.125 C627.313008,1215.125 626.75,1215.71262 626.75,1216.4375 C626.75,1217.16238 627.337891,1217.75 628.037891,1217.75 C628.737891,1217.75 629.325782,1217.16238 629.325782,1216.4375 C629.325782,1215.71262 628.787109,1215.125 628.037891,1215.125 Z M638.822266,1204.97309 C638.655222,1204.75177 638.400625,1204.625 638.123359,1204.625 L626.561328,1204.625 L626.520313,1204.28348 C626.460157,1203.97395 626.189453,1203.75 625.875,1203.75 L623.88164,1203.75 C623.543945,1203.75 623.25,1204.04395 623.25,1204.38164 C623.25,1204.71934 623.543945,1205.0625 623.88164,1205.0625 L625.307343,1205.0625 L626.955625,1213.7168 C627.039844,1214.02578 627.310547,1214.25 627.625,1214.25 L636.59375,1214.25 C636.956055,1214.25 637.25,1213.95605 637.25,1213.61836 C637.25,1213.23008 636.957422,1212.9375 636.59375,1212.9375 L628.16914,1212.9375 L627.917578,1211.625 L636.623827,1211.625 C637.014569,1211.625 637.357734,1211.36605 637.465195,1210.99035 L638.965272,1205.76496 C639.041015,1205.47402 638.989061,1205.19457 638.822265,1204.97309 L638.822266,1204.97309 Z"
                transform="translate(-623 -1203)"
            />
        </svg>
    );
};

export default React.memo(IconCart);
